// Which ways in are on here (`GET /v1/meta`'s `signIn`), as the console's screens read them: the social
// providers this deployment has (F-IAM-03), and whether phone sign-in is on — the Platform's switch,
// `auth.phoneSignIn`, off since the owner's instruction of 2026-10-08 (spec/07 §3.1). One query for both, so
// the sign-in screen, the invitation page and the invite forms agree.
//
// Until the answer comes, nothing is on: a phone option appears only once the server has said it is on, never
// while the answer is on its way, so it never shows and then goes away. A screen that has to choose between
// two paths waits on `isPending` instead.

import { useQuery } from '@tanstack/react-query';

import { useApi } from '../api/client';
import { fetchSignInMethods, type SignInMethods } from '../api/meta';

export const signInMethodsKey = ['meta', 'sign-in'] as const;

const NOTHING_YET: SignInMethods = { social: [], phone: false };

export function useSignInMethods(): SignInMethods & { readonly isPending: boolean } {
  const api = useApi();
  const query = useQuery({ queryKey: signInMethodsKey, queryFn: () => fetchSignInMethods(api), staleTime: 300_000 });
  return { ...(query.data ?? NOTHING_YET), isPending: query.isPending };
}

/** Whether a phone and a code sign anyone in here: `false` until the server says it is on. */
export function usePhoneSignIn(): boolean {
  return useSignInMethods().phone;
}
